<script>
    import Swiper from 'swiper/esm/svelte/swiper.svelte';
    import SwiperSlide from 'swiper/esm/svelte/swiper-slide.svelte';
    import { Autoplay, Navigation, Pagination } from 'swiper/core';
    export let items = [];
</script>

<Swiper className="swiper-container"
    loop={true}
    spaceBetween={20}
    slidesPerView={1}
    autoplay={{
        delay: 10000,
        disableOnInteraction: true
    }}
    navigation={true}
    pagination={true}
    modules={[ Autoplay, Navigation, Pagination ]}>
    {#if Object.entries(items).length > 0}
        {#each Object.entries(items) as [key, value], i ([key, value])}
            {#if typeof value?.attributes?.formats?.thumbnail?.url !== 'undefined' } 
            <SwiperSlide className="swiper-slide">
                <img class="max-image-width" src="https://cms.machs-mit-marketing.de{value?.attributes?.formats?.thumbnail?.url}" srcset="https://cms.machs-mit-marketing.de/{value?.attributes?.formats?.small?.url}" loading="lazy" alt="{value.alternativeText}" />
            </SwiperSlide>
            {/if}
        {/each}
    {/if}
</Swiper>

<style>
img.max-image-width {
    width: 1024px !important;
    height: auto;
    object-fit: cover;
    object-position: center;
}
:global(.swiper-container) {
    margin-left: 0;
    margin-right: 0;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

/* Globaler Stil für alle Swiper-Slides */
.swiper-slide {
    width: 100vw !important;  /* Vollbildbreite */
    max-width: 100% !important;  /* Verhindert, dass eine Maximalbreite gesetzt wird */
    height: fit-content !important;  /* Um sicherzustellen, dass die Höhe automatisch angepasst wird */
    cursor: pointer;
}

/* Stil für Mobilansicht (maximale Breite 350px) */
@media (min-width: 240px) and (max-width: 480px) {
    :global(.swiper-container) {
        min-width: 240px;
    }
}

/* Stil für Standardansicht (maximale Breite 600px) */
@media (min-width: 481px) and (max-width: 600px) {
    :global(.swiper-container) {
        /* Deine Stile für die Standardansicht hier */
        min-width: 480;
        max-width: fit-content;
    }
}

@media (min-width: 601px) and (max-width: 1024px) {
    :global(.swiper-container) {
        /* Deine Stile für die Standardansicht hier */
        max-width: 500px;
        max-width: fit-content;
    }
}

</style>